import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { formatNumber, getSortIndicator } from '../../../../../utils/helpers';
import useSortedData from '../../../hooks/useSortedData';
import './PlayerPicker.css';

const PlayerPickerSnake = ({ players, onPlayerSelect, disabled }) => {
  const [stagedPlayer, setStagedPlayer] = useState(null);

  const { sortedData: sortedPlayers, requestSort, sortConfig } = useSortedData(
    players,
    'sportSpecificData.icmValue',
    'descending'
  );

  const handleStagePlayer = (player) => {
    setStagedPlayer(player);
  };

  const handleConfirmDraft = () => {
    if (disabled || !stagedPlayer) return;
    onPlayerSelect(stagedPlayer);
    setStagedPlayer(null); 
  };

  return (
    <>
      <div className="player-picker-container">
        <div className="player-picker-table-header">
          <span className="player-picker-table-header-text">
            AVAILABLE PLAYERS
          </span>
        </div>
        <table className="player-picker-table">
          <thead>
            <tr>
              <th onClick={() => requestSort('name')}>
                NAME {getSortIndicator(sortConfig, 'name')}
              </th>
              <th onClick={() => requestSort('sportSpecificData.chipCount')}>
                CHIPS {getSortIndicator(sortConfig, 'sportSpecificData.chipCount')}
              </th>
              <th onClick={() => requestSort('sportSpecificData.icmValue')}>
                ICM VALUE {getSortIndicator(sortConfig, 'sportSpecificData.icmValue')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedPlayers.map((player) => (
              <tr 
                key={player.name} 
                className={`player-row ${stagedPlayer?.name === player.name ? 'staged' : ''}`}
                onClick={() => handleStagePlayer(player)}
              >
                <td>{player.name}</td>
                <td>{formatNumber(player.sportSpecificData?.chipCount)}</td>
                <td>${formatNumber(player.sportSpecificData?.icmValue)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="draft-confirmation-bar">
        <input 
          type="text" 
          className="confirmation-input"
          value={stagedPlayer ? stagedPlayer.name : ''} 
          placeholder="Select a player from the list"
          readOnly 
        />
        <button 
          className="draft-btn"
          onClick={handleConfirmDraft}
          disabled={!stagedPlayer || disabled}
        >
          Draft
        </button>
      </div>
    </>
  );
};

PlayerPickerSnake.propTypes = {
  players: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    sportSpecificData: PropTypes.shape({
      chipCount: PropTypes.number,
      icmValue: PropTypes.number,
    })
  })).isRequired,
  onPlayerSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

PlayerPickerSnake.defaultProps = {
  disabled: false,
};

export default PlayerPickerSnake;
